// @flow

import boards from 'app/common/redux/reducers/boards';
import boardSort from 'app/www-unauth/redux/reducers/boardSort';
import euCookieBar from 'app/www-unauth/redux/reducers/euCookieBar';
import experiences from 'app/common/redux/reducers/experiences';
import facebookAutoLogin from 'app/www-unauth/redux/reducers/facebookAutoLogin';
import formReducer from 'redux-form/lib/reducer';
import googleOneTap from 'app/www-unauth/redux/reducers/googleOneTap';
import history from 'app/common/redux/reducers/history';
import inviteObject from 'app/www-unauth/redux/reducers/inviteObject';
import location from 'app/common/redux/reducers/location';
import loggedOutUserInfo from 'app/www-unauth/redux/reducers/loggedOutUserInfo';
import modalBudget from 'app/www-unauth/redux/reducers/modalBudget';
import pins from 'app/common/redux/reducers/pins';
import resources from 'app/common/redux/reducers/resources';
import viewer from 'app/common/redux/reducers/viewer';
import { commonUi } from 'app/common/redux/reducers/ui';
import { combineReducers, type Reducer, type Store } from 'redux';

type DynamicReducers = {
  [name: string]: Reducer<any, any>,
};

export function reducers(dynamicReducers?: DynamicReducers) {
  return {
    boards,
    boardSort,
    euCookieBar,
    experiences,
    form: formReducer,
    location,
    history,
    facebookAutoLogin,
    googleOneTap,
    loggedOutUserInfo,
    modalBudget,
    pins,
    resources,
    ui: commonUi,
    viewer,
    inviteObject,
    ...dynamicReducers,
  };
}

// $FlowFixMe: new errors found from flow 0.96 upgrade
const reducer = (dynamicReducers?: DynamicReducers) => combineReducers(reducers(dynamicReducers));

// $FlowFixMe: New error after Flow Upgrade http://pinch.pinadmin.com/flow53upgdoc
export function addReducer(store: Store, name: string, dynamicReducer: Reducer<*, *>) {
  if (store.dynamicReducers[name]) {
    return;
  }
  store.dynamicReducers = {
    ...store.dynamicReducers,
    [name]: dynamicReducer,
  };
  store.replaceReducer(reducer(store.dynamicReducers));
}

export default reducer;
